/**
 * Post Product Linker (ISS:02-085)
 *
 * - Uses search-menu (Suggest) in post-product-picker mode
 * - Syncs selected product_id to hidden input
 * - Shows a small preview card
 *
 * Setup layer: initialization and module integration.
 */

import { ProductLinkerForm } from "./product-linker-form";
import { ProductLinkerHandler } from "./product-linker-handler";
import { ProductLinkerListener } from "./product-linker-listener";
class PostProductLinker {
    public root: HTMLElement;
    public form: ProductLinkerForm;
    public handler: ProductLinkerHandler;
    public listener: ProductLinkerListener;

    public constructor(root: HTMLElement) {
        this.root = root;
        this.form = new ProductLinkerForm(root);
        this.handler = new ProductLinkerHandler(this.form);
        this.listener = new ProductLinkerListener(this.form, this.handler);
    }

    public async init(): Promise<void> {
        this.listener.register();
        await this.handler.bootstrapInitial();
    }

    public static init(rootEl?: ParentNode | Document | HTMLElement): void {
        const root = rootEl || document;
        ProductLinkerForm.getRoots(root).forEach((node) => {
            if (node.dataset.postProductLinkerInit === "1") return;
            node.dataset.postProductLinkerInit = "1";
            const instance = new PostProductLinker(node);
            void instance.init();
        });
    }
}

export { PostProductLinker };
